import * as React from 'react';
import { compose } from 'redux';
import { connectState } from '../../redux/connect';
import { Form } from '4finance-onion-form-pl';
import { Map } from 'immutable';
import translate from '4finance-translate-pl';
import injectStyles from '4finance-components-pl';
import styles from './EnterNewPassword.jss';
import { Password, SubmitButton } from '../../fields';

var EnterNewPassword = function EnterNewPassword(props) {
  var classes = props.classes,
      msg = props.msg,
      passwordProps = props.passwordProps,
      strongPassword = props.strongPassword,
      customPasswordValidation = props.customPasswordValidation,
      saveNewPassword = props.saveNewPassword;

  var _onSubmit = function _onSubmit(fields) {
    saveNewPassword(fields.values.passwordInput);
  };

  return React.createElement("div", {
    className: classes.container
  }, React.createElement(Form, {
    name: "enterNewPassword",
    onSubmit: _onSubmit,
    resetOnMount: true
  }, React.createElement("div", {
    className: classes.formInnerWrapper
  }, React.createElement("h1", null, msg('enterNewPassword.title')), React.createElement("p", {
    className: classes.description
  }, msg('enterNewPassword.subtitle')), React.createElement("div", {
    className: classes.formControl
  }, React.createElement(Password, {
    name: "passwordInput",
    className: classes.password,
    fieldProps: passwordProps.toJS(),
    strongPassword: strongPassword,
    customPasswordValidation: customPasswordValidation,
    bordered: true
  })), React.createElement(SubmitButton, {
    type: "submit"
  }, msg('enterNewPassword.savePasswordButton')))));
};

EnterNewPassword.styleRoot = 'EnterNewPassword';
EnterNewPassword.defaultProps = {
  classes: {},
  msg: function msg() {
    return '';
  },
  passwordProps: Map()
};
export default compose(connectState({
  passwordProps: ['passwordRecover', 'fieldsProps', 'password']
}), translate, injectStyles(styles))(EnterNewPassword);